import React from "react";
import { Link } from "react-router-dom";
import useLanguage from "../../hooks/useLanguage";
import translationsData from "../../data/translations.json";
import Button from "../common/Button";

const HeroSection = () => {
  const { language } = useLanguage();

  const headline =
    language === "ko"
      ? translationsData.hero.headline
      : translationsData.hero.headlineEn;
  const subheadline =
    language === "ko"
      ? translationsData.hero.subheadline
      : translationsData.hero.subheadlineEn;
  const viewProductsBtn =
    language === "ko"
      ? translationsData.buttons.viewProducts
      : translationsData.buttons.viewProductsEn;
  const contactBtn =
    language === "ko"
      ? translationsData.buttons.contact
      : translationsData.buttons.contactEn;

  return (
    <section
      className="relative min-h-screen flex items-center justify-center text-white"
      style={{
        backgroundImage: "url(/1001.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Background Pattern Overlay */}
      <div className="absolute inset-0 bg-blue-900 opacity-40"></div>

      {/* Content Container */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
        {/* Main Headline */}
        <h1
          className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {headline}
        </h1>

        {/* Sub Headline */}
        <p
          className="text-xl md:text-2xl lg:text-3xl mb-12 text-blue-100 max-w-4xl mx-auto"
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="1000"
        >
          {subheadline}
        </p>

        {/* CTA Buttons */}
        <div
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          data-aos="fade-up"
          data-aos-delay="400"
          data-aos-duration="1000"
        >
          <Link to="/products">
            <Button
              variant="primary"
              size="lg"
              className="w-full sm:w-auto px-8 py-4 text-lg bg-white !text-blue-700 hover:bg-blue-50 !hover:text-white"
            >
              {viewProductsBtn}
            </Button>
          </Link>
          <Link to="/contact">
            <Button
              variant="outline"
              size="lg"
              className="w-full sm:w-auto px-8 py-4 text-lg border-2 border-white !text-white hover:bg-white hover:!text-blue-700"
            >
              {contactBtn}
            </Button>
          </Link>
        </div>
      </div>

      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
};

export default HeroSection;
